import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "play--sprite",
  "use": "play--sprite-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" id=\"play--sprite\">\n\t<g fill=\"none\" fill-rule=\"evenodd\" stroke-linejoin=\"round\">\n\t\t<g stroke=\"#fff\">\n\t\t\t<polygon transform=\"translate(16 16.5) rotate(90) translate(-16 -16.5)\" points=\"16 8 25 25 7 25\" />\n\t\t</g>\n\t</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol